import {
  Heading,
  Box,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Container,
  Button,
  Grid,
  Text,
} from "@chakra-ui/react";
import { MdLocationOn } from "react-icons/md";
import { BiEnvelope } from "react-icons/bi";
import { BsPhone } from "react-icons/bs";
import { FaPaperPlane } from "react-icons/fa";
import LandingLayout from "../Layouts/LandingLayout";
import ContactCard from "../Components/ContactCard";

function Contact() {
  return (
    <LandingLayout bg="brand.100">
      <Container maxW="container.xl">
        <Flex
          p={{ base: ".5rem", lg: "2rem" }}
          alignItems="center"
          justify="space-between"
          flexWrap="wrap"
          mb="4rem"
        >
          <Box mb="2rem">
            <Heading mb="1rem" size="xl">
              Get in Touch
            </Heading>
            <Heading size="md">
              give us a shout, let us know how we can better serve you.{" "}
            </Heading>
          </Box>
          <Box
            bg="white"
            boxShadow="0px 0px 77px 0px rgba(0,0,0,0.05)"
            as="form"
            p={{ base: "2rem", lg: "3rem" }}
            borderRadius="1rem"
            mb="2rem"
          >
            <Heading size="lg">Send Us a Message</Heading>
            <FormControl mb="1rem" id="fullname">
              <FormLabel>Full name</FormLabel>
              <Input type="text" />
            </FormControl>
            <FormControl mb="1rem" id="email">
              <FormLabel>Email address</FormLabel>
              <Input type="email" />
            </FormControl>
            <FormControl mb="1rem" id="subject">
              <FormLabel>Subject</FormLabel>
              <Input type="text" />
            </FormControl>
            <FormControl mb="1rem" id="message">
              <FormLabel>Message</FormLabel>
              <Textarea placeholder="Message" />
            </FormControl>
            <Button
              color="white"
              bg="brand.900"
              variant="solid"
              _hover={{ bg: "brand.900" }}
            >
              Send{" "}
              <Box ml="1rem" display="inline">
                <FaPaperPlane />
              </Box>
            </Button>
          </Box>
        </Flex>

        <Flex flexWrap="wrap" mx="2rem" justify="space-between" mb="4rem">
          <ContactCard>
            <BsPhone fontSize="1.5rem" />
            <Text ml="1rem">+234 8123456789</Text>
          </ContactCard>
          <ContactCard>
            <BiEnvelope fontSize="1.5rem" />
            <Text ml="1rem">promisecardng@gmail.com</Text>
          </ContactCard>
          <ContactCard>
            <MdLocationOn fontSize="1.5rem" />
            <Text ml="1rem">Lagos, Nigeria</Text>
          </ContactCard>
        </Flex>

        <Grid
          gridTemplateColumns={{ base: "1fr", lg: "repeat(2, 1fr)" }}
          columnGap="2rem"
          rowGap="5rem"
          justifyContent="center"
          mb="4rem"
        >
          <Box>
            <Heading mb="1rem" color="brand.900" size="lg">
              Customer Support
            </Heading>
            <Text>
              For any product or technical questions, or to report a bug, please
              use our online form via the Help Center or email
              support@promisecard.ng
            </Text>
          </Box>
          <Box>
            <Heading mb="1rem" color="brand.900" size="lg">
              Media and Press
            </Heading>
            <Text>
              Excited by the Clubhouse story and want to share it with your
              audience? For press inquiries, contact: press@promisecard.ng
            </Text>
          </Box>
          <Box>
            <Heading mb="1rem" color="brand.900" size="lg">
              Partnership and Business
            </Heading>
            <Text>
              For any partnership with PromiseCard and business enquiries,
              contact: partners@promisecard.ng
            </Text>
          </Box>
          <Box>
            <Heading mb="1rem" color="brand.900" size="lg">
              General Enquiries
            </Heading>
            <Text>
              For anything else on your mind, including partnership ideas, say
              hello: hello@promisecard.ng
            </Text>
          </Box>
        </Grid>
      </Container>
    </LandingLayout>
  );
}

export default Contact;
